import { Globals } from '../../../modules/Globals';
import axios from 'axios';
import { ICaja } from '../../../interfaces/ICaja';
import { ICajaResume } from '@/interfaces/ICajaResume';
import { IInvoicingData } from '@/interfaces/IInvoicingData';

const apiUrl = Globals.apiPath + '/invoicing/data';

export default class InvoicingDataService {
  constructor() {}

  static async getByBranch({
    restaurantId,
    branchId,
    platform,
  }: {
    restaurantId: number;
    branchId: number;
    platform: string;
  }): Promise<IInvoicingData> {
    let res = await axios.get<IInvoicingData>(
      `${apiUrl}?restaurantId=${restaurantId}&branchId=${branchId}&platform=${platform}`
    );
    return res.data;
  }

  static async deleteData(id: number): Promise<IInvoicingData> {
    let res = await axios.delete<IInvoicingData>(`${apiUrl}/${id}`);
    return res.data;
  }
}
